import React from 'react';
import styled from 'styled-components/macro';

import { wikinaePalette } from '@mirinae/wikinae/modules/defines/styles';
import IconZoom from '@mirinae/wikinae/components/assets/icon-zoom-30.svg';
import IconDoubleChevron from '@mirinae/wikinae/components/assets/icon-double-chevron-24.svg';
import IconHamburger from '@mirinae/wikinae/components/assets/icon-hamburger-25.svg';
import IconBack from '@mirinae/wikinae/components/assets/icon-arrow-back-25.svg';
import IconClose from '@mirinae/wikinae/components/assets/icon-x-24.svg';

const HeaderButton = styled.button`
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    font-size: 0;
    background: url(${props => (props.icon === 'zoom' ? IconZoom : IconDoubleChevron)}) no-repeat 50%;
    :hover {
        background-color: ${wikinaePalette.effect.shadow};
    }
`;

export default HeaderButton;

const MobileButton = styled.button`
    position: absolute;
    left: 15px;
    top: 12px;
    width: 45px;
    height: 45px;
    font-size: 0;
    background: url(${props => (props.theme === 'back' ? IconBack : props.theme === 'menu' ? IconHamburger : IconClose)}) no-repeat 50%;
`;

export const MobileHeaderButton = (props) => (
    <MobileButton type="button" {...props}>
        {props.theme === 'back' && 'Back'}
        {props.theme === 'menu' && 'Open Menu'}
        {props.theme === 'close' && 'Close Menu'}
    </MobileButton>
);